//offsets sticky elements (powered through sticky-js library) to compensate for current height of the header or in page navigation
function offsetStickyElements() {
    var inPageNavigationElement = $('.in-page-navigation');
    var headerElement = $('.header');
    var offset;

    if (inPageNavigationElement.length) {
        offset = $(inPageNavigationElement).outerHeight();
    }
    else if (headerElement.length) {
        offset = $(headerElement).outerHeight();
    }

    if (offset) {
        $('[data-sticky]').attr('data-margin-top', offset);
    }
}

$(document).ready(function () {
    offsetStickyElements();

    $(window).on('resize', throttle(function () {
        offsetStickyElements();
    }, 400));
});